import { useState } from "react";
import styled from "styled-components";

import { Direction, Flex, Justify, Wrap } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { SelectFieldClean } from "components/organisms/form/SelectField";
import { ToggleFieldClean } from "components/organisms/form/ToggleField";

import { OwnerType } from "generated/graphql-types";

export default function UsersFilter({
	gridOwners,
	gridOwner,
	setGridOwner,
	ownerType,
	setOwnerType,
	notCustomer,
	setNotCustomer,
	fjutt,
	setFjutt,
	production,
	setProduction,
}: Readonly<{
	gridOwners: string[];
	gridOwner: string | null;
	setGridOwner: (newValue: string) => void;
	ownerType: OwnerType[];
	setOwnerType: (newValue: OwnerType[]) => void;
	notCustomer: boolean;
	setNotCustomer: (newValue: boolean) => void;
	fjutt: boolean | null;
	setFjutt: (newValue: boolean | null) => void;
	production: boolean | null;
	setProduction: (newValue: boolean | null) => void;
}>) {
	const onOwnerTypeChange = (type: OwnerType) => {
		let newOwnerTypes: OwnerType[] = [...ownerType];
		if (newOwnerTypes.includes(type)) {
			newOwnerTypes = newOwnerTypes.filter((t) => t !== type);
		} else {
			newOwnerTypes.push(type);
		}
		setOwnerType(newOwnerTypes);
	};

	const boolToStringOption = (value: boolean | null) => {
		if (value === true) return "true";
		if (value === false) return "false";
		return "null";
	};
	const stringOptionToBool = (value: string) => {
		if (value === "true") return true;
		if (value === "false") return false;
		return null;
	};

	const gridOwnerOptions = ["Ikke valgt", ...gridOwners];

	return (
		<FilterWrapper>
			<Flex direction={Direction.row} gap="2rem" alignItems={Justify.start} wrap={Wrap.wrap}>
				<div>
					<label>Kundeforhold</label>
					<div style={{ display: "flex", flexDirection: "column" }}>
						<ToggleFieldClean
							checked={notCustomer}
							label="Ikke kunde"
							onChange={() => setNotCustomer(!notCustomer)}
							labelStyle={{ display: "flex", justifyContent: "space-between" }}
						></ToggleFieldClean>
						<ToggleFieldClean
							checked={ownerType?.includes(OwnerType.OWNER_PRIVATE)}
							label="Privat"
							onChange={() => onOwnerTypeChange(OwnerType.OWNER_PRIVATE)}
							labelStyle={{ display: "flex", justifyContent: "space-between" }}
						></ToggleFieldClean>
						<ToggleFieldClean
							checked={ownerType?.includes(OwnerType.SHARED_PRIVATE)}
							label="Delt privat"
							onChange={() => onOwnerTypeChange(OwnerType.SHARED_PRIVATE)}
							labelStyle={{ display: "flex", justifyContent: "space-between" }}
						></ToggleFieldClean>
						<ToggleFieldClean
							checked={ownerType?.includes(OwnerType.COMPANY)}
							label="Bedrift"
							onChange={() => onOwnerTypeChange(OwnerType.COMPANY)}
							labelStyle={{ display: "flex", justifyContent: "space-between" }}
						></ToggleFieldClean>
						<ToggleFieldClean
							checked={ownerType?.includes(OwnerType.SHARED_COMPANY)}
							label="Delt bedrift"
							onChange={() => onOwnerTypeChange(OwnerType.SHARED_COMPANY)}
							labelStyle={{ display: "flex", justifyContent: "space-between" }}
						></ToggleFieldClean>
					</div>
				</div>
				<div>
					<SelectFieldClean
						name="Fjutt"
						label="Fjutt"
						value={boolToStringOption(fjutt)}
						options={[
							{ label: "Ja", value: "true" },
							{ label: "Nei", value: "false" },
							{ label: "Ikke valgt", value: "null" },
						]}
						setValue={(value) => setFjutt(stringOptionToBool(value))}
					></SelectFieldClean>
				</div>
				<div>
					<SelectFieldClean
						value={gridOwner || ""}
						id="gridOwner"
						name="Netteier"
						label={"Netteier"}
						options={gridOwnerOptions?.map((owner) => ({ label: owner, value: owner === "Ikke valgt" ? "" : owner }))}
						setValue={setGridOwner}
						placeholder=""
					/>
				</div>
				<div>
					<SelectFieldClean
						name="production"
						label="Produksjon"
						value={boolToStringOption(production)}
						options={[
							{ label: "Ja", value: "true" },
							{ label: "Nei", value: "false" },
							{ label: "Ikke valgt", value: "null" },
						]}
						setValue={(value) => setProduction(stringOptionToBool(value))}
					></SelectFieldClean>
				</div>
			</Flex>
		</FilterWrapper>
	);
}

export const FilterWrapper = styled.div`
	padding: 32px;
	background-color: #f6f6f6;
	border-radius: 16px;
`;
